/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PraticaComponenteCreateForm { 
    form_data?: { [key: string]: any; };
    assegnazione_scolastica_id?: string;
    mode?: PraticaComponenteCreateFormModeEnum;
    version: number;
}
export enum PraticaComponenteCreateFormModeEnum {
    PRESA_IN_CARICO = 'PRESA_IN_CARICO',
    AGGIORNA = 'AGGIORNA',
    SOVRASCRIVI_ORIGINALE = 'SOVRASCRIVI_ORIGINALE'
};



